import { FormProvider, useForm } from 'react-hook-form'

import { Form, FormError, OperationButton } from '@/components/core-v2'
import { AuthyCode, AuthyCodeField } from '@/components/core-v2/molecules/fields/authyCode'
import { useLogin2FA } from '@/utilities/hooks/useLogin2FA'

import { COPY } from './constants'
import classes from './index.module.scss'

export type TwoFactorFields = AuthyCodeField

export const TwoFactorForm = () => {
  const form = useForm<TwoFactorFields>()
  const [onSubmit, { isError, isLoading }] = useLogin2FA({
    redirectOnLockedOut: true,
    redirectOnSuccess: true
  })

  return (
    <section>
      <FormProvider {...form}>
        <Form
          aria-busy={isLoading}
          name="Two factor authentication form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <AuthyCode data-private isDisabled={isLoading} />

          <FormError collapseClassName={classes.error} isShowing={isError} title="Error">
            {COPY.invalidCredentials}
          </FormError>

          <OperationButton
            className="mt-10"
            isDisabled={isLoading}
            isLoading={isLoading}
            operationType="progress"
            type="submit"
            width="100%"
          >
            {COPY.button}
          </OperationButton>
        </Form>
      </FormProvider>
    </section>
  )
}
